import * as messageService from "../../services/message.service";
import * as leaseTermService from '../../services/leaseTerm.service';


const state = {
    leaseTermAll:[],
    leaseTermAllActive:[],
};

const getters = {
    gettLeaseTermAll:state => (state.leaseTermAll),
    gettLeaseTermAllActive:state => (state.leaseTermAllActive),
};

const actions = {
    async fetchLeaseTermAll({ commit } ){
        try {
            const response = await leaseTermService.all();
            commit('setLeaseTermAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchLeaseTermAllActive({ commit } ){
        try {
            const response = await leaseTermService.allActive();
            commit('setLeaseTermAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setLeaseTermAll:(state, res) => (
        state.leaseTermAll =  res
    ),
    setLeaseTermAllActive:(state, res) => (
        state.leaseTermAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}